import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { queryClient } from '@/lib/react-query';

export const useUpdateDefinitionMergePaths = () => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: ({ payload }) =>
      axios.patch('api/v2/agent/search/metric/defined-paths', payload),
    onSuccess: (data, { metadata }) => {
      if (metadata?.update) {
        addNotification({
          type: 'success',
          title: 'Merge paths updated successfully.',
        });
        queryClient.refetchQueries({
          queryKey: ['getConnectedDefinitionsList'],
        });
      }
    },
    onError: (error) => {
      addNotification({ type: 'error', title: error.message });
    },
  });
};
